<script setup lang="ts">
import { nothing } from "../lib/maybe";
/**
 * Thesaurus dialog shared by every writing surface.
 */
import { nextTick, useTemplateRef, watch } from "vue";
import ThesaurusLookupBody from "./context/ThesaurusLookupBody.vue";
import ZwDialog from "./ui/ZwDialog.vue";

const props = defineProps<{
  open: boolean;
}>();

const emit = defineEmits<{
  close: [];
}>();

const body = useTemplateRef<InstanceType<typeof ThesaurusLookupBody>>("body");

watch(
  () => props.open,
  async (open) => {
    if (open === false) return;
    await nextTick();
    body.value?.focus();
    body.value?.select();
  },
);
</script>

<template>
  <ZwDialog
    :open="open"
    title="Thesaurus"
    size="palette"
    placement="top"
    show-close
    :z-index="120"
    :description="nothing"
    @close="emit('close')"
  >
    <ThesaurusLookupBody
      ref="body"
      compact-search
      class="zw-thesaurus-dialog-body"
      @applied="emit('close')"
    />
  </ZwDialog>
</template>

<style scoped>
.zw-thesaurus-dialog-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
</style>
